import * as React from 'react'
import { useVehicleForm } from '../../context/VehicleFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GroupsStage = () => {
  const { data, setData, selectedGroups } = useVehicleForm()
  const { t } = useLocalize()

  const handleRemoveGroup = (groupId: number) => {
    const updatedGroups = data?.groups?.filter((id) => id !== groupId) || []
    setData({ ...data, groups: updatedGroups })
  }

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex-1">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('vehicleModule.groups')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        {selectedGroups && selectedGroups.length > 0 ? (
          <div className="tw-flex tw-flex-col tw-gap-2">
            {selectedGroups.map((group) => (
              <div
                key={group.id}
                className="tw-flex tw-items-center tw-justify-between tw-rounded tw-border tw-border-base-300 tw-p-2"
              >
                <span className="tw-text-sm tw-text-content-base">
                  {group.name}
                </span>
                <button
                  type="button"
                  onClick={() => handleRemoveGroup(group.id)}
                  className="tw-text-sm tw-text-error hover:tw-opacity-70"
                >
                  {t('common.delete')}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="tw-text-sm tw-text-gray-500">
            {t('vehicleModule.no-assigned-groups')}
          </p>
        )}
        <button
          type="button"
          className="tw-rounded tw-border tw-border-primary tw-p-2 tw-text-sm tw-font-medium tw-text-primary hover:tw-bg-primary hover:tw-text-white"
          onClick={() => {
            // TODO: Open groups modal
            console.log('Open groups modal')
          }}
        >
          {t('vehicleModule.manage-groups')}
        </button>
      </div>
    </div>
  )
}

export default GroupsStage
